import { detectLanguage } from '../../services/helpers';

// Keep synced with ./index.js since we need this on two places to prevent circular dependencies.

const routesSetup = [
  {
    name: 'Index',
    paths: {
      sv: '',
      dk: '',
      no: '',
      en: '',
      de: '',
      nl: ''
    }
  },
  {
    name: 'Activate',
    paths: {
      sv: 'aktivera-kort',
      dk: 'aktiver-kort',
      no: 'aktivere-kort',
      en: 'activate-card',
      de: 'karte-aktivieren',
      nl: 'kaart-activeren'
    }
  },
  {
    name: 'ActivateDone',
    paths: {
      sv: 'aktivera-kort/klart',
      dk: 'aktiver-kort/færdig',
      no: 'aktivere-kort/ferdig',
      en: 'activate-card/done',
      de: 'karte-aktivieren/abgeschlossen',
      nl: 'kaart-activeren/gedaan'
    }
  },
  {
    name: 'ActivateAdidas',
    paths: {
      sv: 'aktivera-kort/adidas',
      dk: 'aktiver-kort/adidas',
      no: 'aktivere-kort/adidas',
      en: 'activate-card/adidas',
      de: 'activate-card/adidas',
      nl: 'kaart-activeren/adidas'
    }
  },
  {
    name: 'ActivatePlus',
    paths: {
      sv: 'aktivera-kort/plus',
      dk: 'aktiver-kort/plus',
      no: 'aktivere-kort/plus',
      en: 'activate-card/plus',
      de: 'activate-card/plus',
      nl: 'kaart-activeren/plus'
    }
  },
  {
    name: 'Webshop',
    paths: {
      sv: 'webshop',
      dk: 'webshop',
      no: 'webshop',
      en: 'webshop',
      de: 'webshop',
      nl: 'webshop'
    }
  },
  {
    name: 'GolfCourses',
    paths: {
      sv: 'golfbanor',
      dk: 'golfbaner',
      no: 'golfbaner',
      en: 'golf-courses',
      de: 'golf-courses',
      nl: 'golfbanen'
    }
  },
  {
    name: 'Map',
    paths: {
      sv: 'karta',
      dk: 'kort',
      no: 'kart',
      en: 'map',
      de: 'karte',
      nl: 'kaart'
    }
  },
  {
    name: 'Contest',
    paths: {
      sv: 'tavla',
      dk: 'konkurrence/upc',
      no: 'konkurranse',
      en: null,
      de: null,
      nl: null
    }
  },
  {
    name: 'Compete',
    paths: {
      sv: 'tavla',
      dk: 'konkurrence',
      no: 'konkurranse',
      en: null,
      de: null,
      nl: null
    }
  },
  {
    name: 'Trophy',
    paths: {
      sv: 'tavla/trophy',
      dk: 'konkurrence/trophy',
      no: 'konkurranse/trophy',
      en: null,
      de: null,
      nl: null
    }
  },
  {
    name: 'Upc',
    paths: {
      sv: 'tavla/upc',
      dk: 'konkurrence/upc',
      no: 'tavla/upc',
      en: null,
      de: null,
      nl: null
    }
  },
  // {
  //   name: 'IndoorOpen',
  //   paths: {
  //     sv: 'tavla/indoor-open',
  //     dk: null,
  //     no: null,
  //     en: null,
  //     de: null,
  //   }
  // },
  // {
  //   name: 'MinHusbilOpen',
  //   paths: {
  //     sv: 'tavla/minhusbil-open',
  //     dk: null,
  //     no: null,
  //     en: null,
  //     de: null,
  //   }
  // },
  {
    name: 'Contests',
    paths: {
      sv: 'tavla/program',
      dk: 'konkurrence/program',
      no: 'konkurranse/skjema',
      en: null,
      de: null,
      nl: null
    }
  },
  {
    name: 'TrophyPartners',
    paths: {
      sv: 'tavla/trophy/partners',
      dk: 'konkurrence/trophy/partnere',
      no: 'konkurranse/trophy/partners',
      en: null,
      de: null,
      nl: null
    }
  },
  {
    name: 'UpcPartners',
    paths: {
      sv: 'tavla/upc/partners',
      dk: null,
      no: null,
      en: null,
      de: null,
      nl: null
    }
  },
  {
    name: 'TrophyBroHof',
    paths: {
      sv: 'tavla/trophy/final',
      dk: 'konkurrence/trophy/finale',
      no: 'konkurranse/trophy/finale',
      en: null,
      de: null,
      nl: null
    }
  },
  {
    name: 'ContestOrderOfMerit',
    paths: {
      sv: 'tavla/order-of-merit',
      dk: 'konkurrence/order-of-merit',
      no: 'konkurranse/order-of-merit',
      en: 'contest/order-of-merit',
      de: null,
      nl: null
    }
  },
  {
    name: 'Final',
    paths: {
      sv: 'tavla/final',
      dk: null,
      no: null,
      en: null,
      de: null,
      nl: null
    }
  },
  {
    name: 'Plus',
    paths: {
      sv: 'plus',
      dk: 'plus',
      no: 'plus',
      en: 'plus',
      de: 'plus',
      nl: 'plus'
    }
  },
  {
    name: 'Account',
    paths: {
      sv: 'min-golf',
      dk: 'min-golf',
      no: 'min-golf',
      en: 'my-golf',
      de: 'my-golf',
      nl: 'my-golf'
    }
  },
  {
    name: 'Login',
    paths: {
      sv: 'min-golf/logga-in',
      dk: 'min-golf/log-ind',
      no: 'min-golf/logg-in',
      en: 'my-golf/login',
      de: 'my-golf/login',
      nl: 'my-golf/login'
    }
  },
  {
    name: 'News',
    paths: {
      sv: 'nyheter',
      dk: 'nyheder',
      no: 'nyheter',
      en: 'news',
      de: 'neuigkeiten',
      nl: 'nieuws'
    }
  },
  {
    name: 'Faq',
    paths: {
      sv: 'faq',
      dk: 'faq',
      no: 'faq',
      en: 'faq',
      de: 'faq',
      nl: 'faq'
    }
  },
  {
    name: 'About',
    paths: {
      sv: 'om-oss',
      dk: 'om-os',
      no: 'om-oss',
      en: 'about',
      de: 'about',
      nl: 'over-ons'
    }
  },
  {
    name: 'Retailers',
    paths: {
      sv: 'aterforsaljare',
      dk: 'forhandler',
      no: 'forhandler',
      en: null,
      de: null,
      nl: null
    }
  },
  {
    name: 'Contact',
    paths: {
      sv: 'kontakt',
      dk: 'kontakt',
      no: 'kontakt',
      en: 'contact',
      de: 'contact',
      nl: 'contact'
    }
  },
  {
    name: 'Press',
    paths: {
      sv: 'press',
      dk: 'press',
      no: 'press',
      en: 'press',
      de: 'press',
      nl: 'pers'
    }
  },
  {
    name: 'Terms',
    paths: {
      sv: 'kopvillkor',
      dk: 'vilkar',
      no: 'vilkar',
      en: 'terms',
      de: 'terms',
      nl: 'voorwaarden'
    }
  },
  {
    name: 'Privacy',
    paths: {
      sv: 'integritetspolicy',
      dk: 'privatlivspolitik',
      no: 'personvern',
      en: 'privacy-policy',
      de: 'privacy-policy',
      nl: 'privacybeleid'
    }
  },
  {
    name: 'Cookies',
    paths: {
      sv: 'cookies',
      dk: 'cookies',
      no: 'cookies',
      en: 'cookies',
      de: 'cookies',
      nl: 'cookies'
    }
  },
  {
    name: 'Recommend',
    paths: {
      sv: 'rekommendera',
      dk: 'anbefale',
      no: 'anbefale',
      en: 'recommend',
      de: null,
      nl: 'aanbevelen'
    }
  },
  {
    name: 'GolfClub',
    paths: {
      sv: 'golfklubb',
      dk: 'golfklub',
      no: 'golfklubb',
      en: 'golf-club',
      de: 'golf-club',
      nl: 'golfclub'
    }
  },
  {
    name: 'Survey',
    paths: {
      sv: 'undersokning',
      dk: 'undersøgelse',
      no: 'undersøkelse',
      en: 'survey',
      de: 'survey',
      nl: 'enquete'
    }
  },
  {
    name: 'HowItWorks',
    paths: {
      sv: 'sa-fungerar-det',
      dk: 'sådan-fungerer-det',
      no: 'slik-det-fungerer',
      en: 'how-it-works',
      de: 'so-funktioniert-es',
      nl: 'hoe-het-werkt'
    }
  },
  {
    name: 'Campaign',
    paths: {
      sv: 'kampanj',
      dk: 'kampagne',
      no: 'kampanje',
      en: 'campaign',
      de: 'kampagne',
      nl: 'campagne'
    }
  },
  {
    name: 'Campaignp',
    paths: {
      sv: 'kampanjp',
      dk: 'kampagnep',
      no: 'kampanjep',
      en: 'campaignp',
      de: 'kampagnep',
      nl: 'campagnep'
    }
  },
  {
    name: 'Deals',
    paths: {
      sv: 'deals',
      dk: 'deals',
      no: '',
      en: '',
      de: 'angebote',
      nl: 'aanbiedingen'
    }
  },
  {
    name: 'Deal',
    paths: {
      sv: 'deals/:name',
      dk: 'deals/:name',
      no: 'deals/:name',
      en: null,
      de: 'angebote/:name',
      nl: 'aanbiedingen/:name'
    }
  },
  {
    name: 'SeasonOpen',
    paths: {
      sv: 'golfsäsongen-2026',
      dk: 'golfsæson-2026',
      no: 'golfsesong-2026',
      en: 'golf-season-2026',
      de: 'golf-saison-2026',
      nl: 'golf-seizoen-2026'
    }
  },
  {
    name: 'SASEuroBonusPoints',
    paths: {
      sv: 'partners/sas-eurobonus',
      dk: 'partners/sas-eurobonus',
      no: 'partners/sas-eurobonus',
      en: '',
      de: '',
      nl: null
    }
  },
  {
    name: 'CustomerClub',
    paths: {
      sv: 'kund-klubb',
      dk: 'kunde-klub',
      no: 'kunde-klubb',
      en: 'customer-club',
      de: 'kunden-club',
      nl: 'klantenclub'
    }
  },
  // new Golfamore Events
  {
    name: 'Events',
    paths: {
      sv: 'events',
      dk: null,
      no: null,
      en: null,
      de: null,
      nl: null
    }
  },
  {
    name: 'Competitions',
    paths: {
      sv: 'events/tävlingar',
      dk: 'events/under-par-challenge',
      no: null,
      en: null,
      de: null,
      nl: null
    }
  },
  {
    name: 'CompetitionGolfamoreTrophy',
    paths: {
      sv: 'events/golfamore-trophy',
      dk: null,
      no: 'events/golfamore-trophy',
      en: null,
      de: null,
      nl: null
    }
  },
  {
    name: 'CompetitionUnderParChallenge',
    paths: {
      sv: 'events/under-par-challenge',
      dk: 'events/under-par-challenge',
      no: null,
      en: null,
      de: null,
      nl: null
    }
  },
  {
    name: 'CompetitionFootJoyMasters',
    paths: {
      sv: 'events/footjoy-masters',
      dk: null,
      no: null,
      en: null,
      de: null,
      nl: null
    }
  },
  // {
  //   name: 'CompetitionIndoorOpen',
  //   paths: {
  //     sv: 'events/indoor-open',
  //     dk: null,
  //     no: null,
  //     en: null,
  //     de: null,
  //   }
  // },
  {
    name: 'Calendar',
    paths: {
      sv: 'events/tavlingskalendern',
      dk: 'events/turneringskalender',
      no: 'events/tuneringskalender',
      en: null,
      de: null,
      nl: null
    }
  },
  {
    name: 'OrderOfMerit',
    paths: {
      sv: 'events/order-of-merit',
      dk: 'events/order-of-merit',
      no: 'events/order-of-merit',
      en: null,
      de: null,
      nl: null
    }
  },
  {
    name: 'Tours',
    paths: {
      sv: 'events/on-tour',
      dk: 'events/on-tour',
      no: null,
      en: 'events/on-tour',
      de: 'events/on-tour',
      nl: null
    }
  },
  {
    name: 'Extreme',
    paths: {
      sv: 'events/extreme',
      dk: null,
      no: null,
      en: null,
      de: null,
      nl: null
    }
  },
  {
    name: 'TourBroHof',
    paths: {
      // sv: 'events/on-tour-bro-hof',
      sv: 'webshop',
      dk: null,
      no: null,
      en: null,
      de: null,
      nl: null
    }
  },
  {
    name: 'TourTheNational',
    paths: {
      // sv: 'events/on-tour-the-national',
      sv: 'webshop',
      dk: null,
      no: null,
      en: null,
      de: null,
      nl: null
    }
  },
  {
    name: 'TourVallda',
    paths: {
      // sv: 'events/on-tour-vallda',
      sv: 'webshop',
      dk: null,
      no: null,
      en: null,
      de: null,
      nl: null
    }
  },
  {
    name: 'TourOsteraker',
    paths: {
      // sv: 'events/on-tour-osteraker',
      sv: 'webshop',
      dk: null,
      no: null,
      en: null,
      de: null,
      nl: null
    }
  },
  {
    name: 'TourHalmstad',
    paths: {
      // sv: 'events/on-tour-halmstad',
      sv: 'webshop',
      dk: null,
      no: null,
      en: null,
      de: null,
      nl: null
    }
  },
  {
    name: 'Academy',
    paths: {
      sv: 'akademin',
      dk: 'akademi',
      no: 'akademi',
      en: 'academy',
      de: 'akademie',
      nl: 'academie'
    }
  },
  {
    name: 'WhyBuyCard',
    paths: {
      sv: 'varfor-kopa-kortet',
      dk: 'hvorfor-kobe-kortet',
      no: 'plhvorfor-kjope-kortetus',
      en: 'why-buy-the-card',
      de: 'warum-die-karte-kaufen',
      nl: 'waarom-de-kaart-kopen'
    }
  },
  {
    name: 'KustomPayment',
    paths: {
      sv: 'betalning',
      dk: 'betaling',
      no: 'betaling',
      en: 'payment',
      de: 'zahlung',
      nl: 'betaling'
    }
  },
  {
    name: 'KustomReceipt',
    paths: {
      sv: 'betalning/kvitto',
      dk: 'betaling/kvittering',
      no: 'betaling/kvittering',
      en: 'payment/receipt',
      de: 'zahlung/quittung',
      nl: 'betaling/ontvangstbewijs'
    }
  },
  {
    name: 'OnTour',
    paths: {
      sv: 'ontour',
      dk: 'ontour',
      no: null,
      en: 'ontour',
      de: 'ontour',
      nl: null
    }
  },
  {
    name: 'ScorecardSurvey',
    paths: {
      sv: 'scorecard-survey',
      dk: null,
      no: null,
      en: 'scorecard-survey',
      de: null,
      nl: null
    }
  },
  {
    name: 'RegretOrder',
    paths: {
      sv: 'angerratt',
      dk: 'fortrydelsesret',
      no: 'angrerett',
      en: 'right-of-withdrawal',
      de: 'widerruf',
      nl: 'herroepingsrecht'
    }
  },
  {
    name: 'Redirect',
    paths: {
      sv: 'r',
      dk: 'r',
      no: 'r',
      en: 'r',
      de: 'r',
      nl: 'r'
    }
  }
];

const languageCode = detectLanguage();

const paths = routesSetup.reduce((add, cur) => {
  add[cur.name] = `/${languageCode}/${cur.paths[languageCode]}/`;
  return add;
}, {});

const getPath = (lang, route) =>
  paths[route] ? paths[route] : new Error(`Path could not be found for route ${route} in language ${lang}`);

export default getPath;
